module.exports = __webpack_public_path__ + "img/service.5f8f6e6d.jpg";